import * as designBuilderApi from '../api/designBuilder';
import estimateLoaded from './estimateLoaded';
import loaded from './loaded';
import loading from './loading';
import globalError from './globalError';
import brokerSaveDesign from '../api/designBuilder/brokerSaveDesign';
import config from '../helpers/config';
import * as thdUser from '../../common/thdUserInfo';
import { sites } from '../helpers/globalVariables';

export default newName => (dispatch, getState) => {
  dispatch(loading());

  const { uiState } = getState().estimateBuilder;
  const { selectedEstimate } = uiState;

  return designBuilderApi
    .renameDesign(selectedEstimate, newName)
    .then((response) => {
      dispatch(estimateLoaded(response.data));
      dispatch(loaded());
      const userInfo = thdUser.getLoggedInUserInfo();
      if (config.siteId === sites.theHomeDepot && userInfo && userInfo.identityId) {
        dispatch(brokerSaveDesign(userInfo.identityId, selectedEstimate, newName));
      }
    })
    .catch(() => {
      dispatch(loaded());
      dispatch(globalError());
    });
};
